import { render, staticRenderFns } from "./ObjectivesGainsTable.vue?vue&type=template&id=aa53c990&scoped=true&"
import script from "./ObjectivesGainsTable.vue?vue&type=script&lang=js&"
export * from "./ObjectivesGainsTable.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivesGainsTable.vue?vue&type=style&index=0&id=aa53c990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa53c990",
  null
  
)

export default component.exports